import { StorageTypes } from './getProjectId';

export enum UserTypes {
  EMAIL = 'email',
  PASSWORDLESS = 'passwordless',
  SOCIAL = 'social',
  DEVICE = 'device',
  CUSTOM = 'custom'
}

export type UserData = {
  id: string;
  registeredDate: string;
  group: string;
  email?: string;
  phone?: string;
  externalId?: string;
};

export type BrowserName = 'chromium' | 'firefox' | 'webkit';
type ProjectMap = Record<
  | `${BrowserName}-${UserTypes.EMAIL}-${StorageTypes}`
  | `${BrowserName}-${
      | UserTypes.PASSWORDLESS
      | UserTypes.SOCIAL
      | UserTypes.DEVICE
      | UserTypes.CUSTOM}`,
  UserData
>;

export const getUserData = (
  browserName: BrowserName,
  userType: UserTypes,
  storageType?: StorageTypes
): UserData => {
  const projectIdMap: ProjectMap = {
    'chromium-email-xsolla': {
      id: '2269c933-b0c8-4740-8f83-1c7d6fe82fd5',
      registeredDate: 'Registered on 06/04/2022',
      group: 'default',
      email: 'i.kukarkin@xsolla.com'
    },
    'chromium-email-playfab': {
      id: 'ca37373d-bf60-45d9-a976-4d620a70297d',
      email: 'i.kukarkin+chrome@xsolla.com',
      registeredDate: 'Registered on 06/04/2022',
      group: 'default',
      externalId: '59AC8A9F38C1A899'
    },
    'chromium-email-firebase': {
      id: 'c9ce28f6-af77-4897-bd1e-d357cc3a9068',
      registeredDate: 'Registered on 06/06/2022',
      group: 'default',
      email: 'i.kukarkin-chrome@xsolla.com',
      externalId: '3A6Q9nRxMwSekdNXCcTPwt5XRKv1'
    },
    'chromium-email-custom': {
      id: '402b4a5a-d73a-4b88-a7a7-2d0c536e93e7',
      registeredDate: 'Registered on 11/24/2023',
      group: 'default',
      email: 'w.wong@xsolla.com'
    },
    'chromium-passwordless': {
      id: '45c1660a-73d7-437e-9ac1-fbe5094220ec',
      registeredDate: 'Registered on 06/04/2022',
      group: 'default',
      phone: '912 980-44-64'
    },
    'chromium-social': {
      id: 'f3225b48-1428-4d01-8551-1993fec36184',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022'
    },
    'chromium-device': {
      id: '9ffbd6f8-c09e-4ef1-b509-7ab862a5aac4',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022'
    },
    'chromium-custom': {
      id: '642639da-f58b-4724-86c0-3bd2a03662d7',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022',
      externalId: 'test-custom-id'
    },
    'firefox-email-xsolla': {
      id: 'e58caf35-989e-4da2-8a89-a76a614bac7c',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022',
      email: 'i.kukarkin@xsolla.com'
    },
    'firefox-email-playfab': {
      id: '493e9104-b4b9-407e-a32b-b0582f7d71f0',
      email: 'i.kukarkin+firefox@xsolla.com',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022',
      externalId: 'EC2EC668AE0AADDE'
    },
    'firefox-email-firebase': {
      id: '8caa4d0d-f359-41b3-9bd8-1b8576a3abd4',
      registeredDate: 'Registered on 06/06/2022',
      email: 'i.kukarkin-firefox@xsolla.com',
      group: 'default',
      externalId: 'OXtabkQBezMwh0CeVDesMrmfM6B3'
    },
    'firefox-email-custom': {
      id: 'cd9d74f9-da44-43a1-a17d-c6a89f674720',
      group: 'default',
      registeredDate: 'Registered on 12/14/2023',
      email: 'w.wong@xsolla.com'
    },
    'firefox-passwordless': {
      id: 'f20e2c25-450e-4d9b-9244-2841f7c4855d',
      registeredDate: 'Registered on 06/04/2022',
      group: 'default',
      phone: '912 980-44-64'
    },
    'firefox-social': {
      id: 'd69074ec-ff70-46cb-afac-79f88afcfb66',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022'
    },
    'firefox-device': {
      id: '1729e1ac-d6cb-4dc3-a6ca-b49d5e5e9332',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022'
    },
    'firefox-custom': {
      id: '33e8c68d-4f6e-4dbf-af45-766ddbcccbfb',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022',
      externalId: 'test-custom-id'
    },
    'webkit-email-xsolla': {
      id: '2c3c0ea8-0e58-4c3f-a894-edb356806553',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022',
      email: 'i.kukarkin@xsolla.com'
    },
    'webkit-email-playfab': {
      id: '3cdda158-2e0b-4258-b3ce-6acf4e567652',
      email: 'i.kukarkin+safary@xsolla.com',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022',
      externalId: '7ACA43B714BE8AFB'
    },
    'webkit-email-firebase': {
      id: '0d613859-3ec5-4570-b5e1-8fef0112ea99',
      registeredDate: 'Registered on 06/06/2022',
      email: 'i.kukarkin-safari@xsolla.com',
      group: 'default',
      externalId: 'HTP0YpEq0CZDmtUiJqbw0Xv0gFj1'
    },
    'webkit-email-custom': {
      id: '2d085c54-64e6-4f62-b638-1273a28f7cca',
      registeredDate: 'Registered on 12/14/2023',
      group: 'default',
      email: 'w.wong@xsolla.com'
    },
    'webkit-passwordless': {
      id: '112796d9-3adf-473a-8389-16da703f144c',
      registeredDate: 'Registered on 06/04/2022',
      group: 'default',
      phone: '912 980-44-64'
    },
    'webkit-social': {
      id: 'cc0ee0fb-453b-4fae-a9b4-27b96fb357eb',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022'
    },
    'webkit-device': {
      id: '2502fcd2-4787-44fd-ae4f-1f5fc31cf577',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022'
    },
    'webkit-custom': {
      id: '156cf69f-4a71-419b-8d9d-81f8389d9f35',
      group: 'default',
      registeredDate: 'Registered on 06/04/2022',
      externalId: 'test-custom-id'
    }
  };

  if (storageType && userType === UserTypes.EMAIL) {
    return projectIdMap[`${browserName}-${userType}-${storageType}`];
  }

  if (userType !== UserTypes.EMAIL) {
    return projectIdMap[`${browserName}-${userType}`];
  }

  return { id: '', registeredDate: '', group: 'default' };
};
